const options = {
  5: "bg-purple-600/5",
  10: "bg-purple-600/10",
  25: "bg-purple-600/25",
  50: "bg-purple-600/50",
  75: "bg-purple-600/75",
  90: "bg-purple-600/90",
  100: "bg-purple-600",
};

const from = {
  5: "from-purple-600/5",
  10: "from-purple-600/10",
  25: "from-purple-600/25",
  50: "from-purple-600/50",
  75: "from-purple-600/75",
  90: "from-purple-600/90",
  100: "from-purple-600",
};

export default function getBackgroundPurple600(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
